import { Col, Flex, Modal, Row, Button } from "antd";
import cx from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import { initialValues } from "features/employee/schemas/employeeModalSchema";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
// import schema from "features/company/schemas/companyModalLevelSchema";
import styles from "./Modal.module.css";
import { useTranslation } from "react-i18next";
import { Input, InputNumber } from "components/form";
import LeaveBenefitSchema from "features/employee/schemas/employeeModalSchema";

// import { Select, Input } from "components/form";


function ModalLeaveBenefit({
    setIsModalOpen,
    isModalOpen,
    leaveGroupOptions = [],
    getInfo = () => { },
    onEdit = () => { },
    onSubmit = () => { },
    onCancel = () => { },
    initailValue
}) {
    const { i18n, t } = useTranslation();

    return (
        <Modal
            destroyOnClose
            title={
                t('leave_benefit.label.edit_leave_quota')
            }
            className={cx(styles.customStyle)}
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            footer={null}
            closable={false}
            maskClosable={false}
            width={"45vw"}
        >
            <Formik
                enableReinitialize
                initialValues={{
                    ...initailValue,
                    leaveTypeName: i18n.language === "en" ? initailValue?.leaveTypeDetails?.leaveTypeNameEn : initailValue?.leaveTypeDetails?.leaveTypeName,
                    totalLeaveDays: initailValue?.leaveTypeDetails?.totalLeaveDays,
                    totalLeaveHour: initailValue?.leaveTypeDetails?.totalLeaveHour,
                }}
                validationSchema={LeaveBenefitSchema}
                onSubmit={(values) => {
                    onSubmit(values); // เรียกใช้งานฟังก์ชัน onSubmit ที่รับค่า values
                }}
            >
                {({ values = {}, setFieldValue = () => { }, getFieldValue = () => { }, setTouched = () => { }, isValid, dirty }) => {
                    getFieldValue()

                    return (
                        <Form>
                            <Flex vertical style={{ rowGap: 16 }}>
                                <Row gutter={[0, 12]}>
                                    <Col span={10} style={{ paddingRight: "8px" }}>
                                        <Input
                                            name="leaveTypeName"
                                            label={t('leave_type.label.leave_type')}
                                            placeholder={t('please-select-1')}
                                            size="large"
                                            disabled
                                        />
                                    </Col>
                                    <Col span={7} style={{ padding: "0px 8px" }}>
                                        <InputNumber
                                            name="totalLeaveDays"
                                            label={t('leave_benefit.label.leave_day')}
                                            size="large"
                                            placeholder="0"
                                            onChange={(value) => {
                                                setFieldValue('leaveDay', value)
                                            }}
                                            required
                                            min={0}
                                            step={1}
                                            max={999}
                                            controls={false}
                                            textAlign="left"
                                            formatter={(value) => value ? value.replace(/(\.\d{2})\d+$/, "$1") : ""}
                                            onKeyDown={(e) => {
                                                const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                                const isNumberKey = e.key >= "0" && e.key <= "9";

                                                if (allowedKeys.includes(e.key)) return;

                                                if (!isNumberKey) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </Col>

                                    <Col span={7} style={{ paddingLeft: "8px" }}>
                                        <InputNumber
                                            name="totalLeaveHour"
                                            label={t('leave_benefit.label.leave_hour')}
                                            size="large"
                                            placeholder="0"
                                            onChange={(value) => {
                                                setFieldValue('leaveHour', value)
                                            }}
                                            required
                                            min={0}
                                            step={1}
                                            max={999}
                                            controls={false}
                                            textAlign="left"
                                            formatter={(value) => value ? value.replace(/(\.\d{2})\d+$/, "$1") : ""}
                                            onKeyDown={(e) => {
                                                const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                                const isNumberKey = e.key >= "0" && e.key <= "9";

                                                if (allowedKeys.includes(e.key)) return;

                                                if (!isNumberKey) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </Col>

                                </Row>

                                <Row justify="end" style={{ gap: 10 }}>
                                    <Button type="default" onClick={() => {
                                        onCancel();
                                    }}
                                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}
                                    >
                                        {t("common.cancel").toUpperCase()}
                                    </Button>

                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        disabled={!dirty || !isValid}
                                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: !dirty || !isValid ? "" : "var(--button-color)" }}
                                    >
                                        {t("common.submit").toUpperCase()}
                                    </Button>
                                </Row>
                            </Flex>

                        </Form>
                    );
                }}
            </Formik>
        </Modal>
    );
}

export default ModalLeaveBenefit;
